export default "__VITE_ASSET__52840e9a__"